/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, action: NonNullable<unknown> }} Seo_Endpoint_Q_ReliableInputs */

const en_seo_endpoint_q_reliable = /** @type {(inputs: Seo_Endpoint_Q_ReliableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`How reliable is the ${i?.name} ${i?.action} API?`)
};

const zh_hans1_seo_endpoint_q_reliable = /** @type {(inputs: Seo_Endpoint_Q_ReliableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action} API 的可靠性如何？`)
};

const pt_br2_seo_endpoint_q_reliable = /** @type {(inputs: Seo_Endpoint_Q_ReliableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quão confiável é o endpoint ${i?.action} da API para ${i?.name}?`)
};

const es_seo_endpoint_q_reliable = /** @type {(inputs: Seo_Endpoint_Q_ReliableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Qué tan confiable es el endpoint ${i?.action} de la API de ${i?.name}?`)
};

const fr_seo_endpoint_q_reliable = /** @type {(inputs: Seo_Endpoint_Q_ReliableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quelle est la fiabilité de l’API ${i?.name} ${i?.action} ?`)
};

const de_seo_endpoint_q_reliable = /** @type {(inputs: Seo_Endpoint_Q_ReliableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wie zuverlässig ist die ${i?.name}-${i?.action}-API?`)
};

const ru_seo_endpoint_q_reliable = /** @type {(inputs: Seo_Endpoint_Q_ReliableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Насколько надёжен API ${i?.name} ${i?.action}?`)
};

const it_seo_endpoint_q_reliable = /** @type {(inputs: Seo_Endpoint_Q_ReliableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quanto è affidabile l'API ${i?.name} ${i?.action}?`)
};

/**
* | output |
* | --- |
* | "How reliable is the {name} {action} API?" |
*
* @param {Seo_Endpoint_Q_ReliableInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_q_reliable = /** @type {((inputs: Seo_Endpoint_Q_ReliableInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_Q_ReliableInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_q_reliable(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_q_reliable(inputs)
	if (locale === "es") return es_seo_endpoint_q_reliable(inputs)
	if (locale === "fr") return fr_seo_endpoint_q_reliable(inputs)
	if (locale === "de") return de_seo_endpoint_q_reliable(inputs)
	if (locale === "ru") return ru_seo_endpoint_q_reliable(inputs)
	if (locale === "it") return it_seo_endpoint_q_reliable(inputs)
	return en_seo_endpoint_q_reliable(inputs)
});